export default __webpack_public_path__ + "static/media/rnr-sports-table-15.20ab3a4c.webp";